'use client';
import { useGetSrSupplierQuery } from '../../api';

export const Certifications = ({
  requestId,
  matchId,
}: {
  requestId: string;
  matchId: string;
}) => {
  const { data: supplier } = useGetSrSupplierQuery({
    id: requestId,
    matchId,
  });

  return (
    <div className="p-4 space-y-6">
      <div className="flex flex-col gap-4">
        <span className="text-xl font-bold">Certifications</span>
        <div className="flex gap-4 flex-wrap bg-[#F1F3FF] rounded-[2rem]">
          <div className="space-y-4 divide-y divide-[#9CACFF] w-full">
            {supplier?.supplierData?.demographicCertifications?.map(
              (certification, index) => (
                <div key={index} className="w-full">
                  <div className="flex w-full md:w-1/2 justify-between p-4">
                    <div className="space-y-2">
                      <div className="flex flex-col">
                        <span className="text-text-primary font-[500]">
                          Certification Name
                        </span>
                        <span className="text-text-secondary">
                          {certification.name}
                        </span>
                      </div>
                      <div className="flex flex-col">
                        <span className="text-text-primary font-[500]">
                          Certification Agency
                        </span>
                        <span className="text-text-secondary">
                          {certification.agency}
                        </span>
                      </div>
                      <div className="flex flex-col">
                        <span className="text-text-primary font-[500]">
                          Certification Type
                        </span>
                        <span className="text-text-secondary">
                          {certification.type}
                        </span>
                      </div>
                    </div>
                    <div className="space-y-2">
                      <div className="flex flex-col">
                        <span className="text-text-primary font-[500]">
                          Certification Date
                        </span>
                        <span className="text-text-secondary">
                          {certification.date}
                        </span>
                      </div>
                      <div className="flex flex-col">
                        <span className="text-text-primary font-[500]">
                          Certification Number
                        </span>
                        <span className="text-text-secondary">
                          {certification.number}
                        </span>
                      </div>
                      <div className="flex flex-col">
                        <span className="text-text-primary font-[500]">
                          Certification Status
                        </span>
                        <span className="text-text-secondary">
                          {certification.status}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )
            )}
            {supplier?.supplierData?.industryCertifications?.map(
              (certification, index) => (
                <div key={index} className="w-full">
                  <div className="flex w-full md:w-1/2 justify-between p-4">
                    <div className="space-y-2">
                      <div className="flex flex-col">
                        <span className="text-text-primary font-[500]">
                          Certification Name
                        </span>
                        <span className="text-text-secondary">
                          {certification.name}
                        </span>
                      </div>
                      <div className="flex flex-col">
                        <span className="text-text-primary font-[500]">
                          Certification Agency
                        </span>
                        <span className="text-text-secondary">
                          {certification.agency}
                        </span>
                      </div>
                      <div className="flex flex-col">
                        <span className="text-text-primary font-[500]">
                          Certification Type
                        </span>
                        <span className="text-text-secondary">
                          {certification.type}
                        </span>
                      </div>
                    </div>
                    <div className="space-y-2">
                      <div className="flex flex-col">
                        <span className="text-text-primary font-[500]">
                          Certification Date
                        </span>
                        <span className="text-text-secondary">
                          {certification.date}
                        </span>
                      </div>
                      <div className="flex flex-col">
                        <span className="text-text-primary font-[500]">
                          Certification Number
                        </span>
                        <span className="text-text-secondary">
                          {certification.number}
                        </span>
                      </div>
                      <div className="flex flex-col">
                        <span className="text-text-primary font-[500]">
                          Certification Status
                        </span>
                        <span className="text-text-secondary">
                          {certification.status}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
